// extracted by mini-css-extract-plugin
export default {"counter":"webpack-containers-Review-Home-StageProgressSummary-StageProgressSummary-module__counter"};